import classnames from 'classnames'
import RadioList from './RadioList'

import './verticalRadioList.scss'


const VerticalRadioList = props => <RadioList {...props} className={classnames('vertical-radio-list', props.className)} />

export default VerticalRadioList
